import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/mocks/site';

export default function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-5xl px-4 py-14 md:px-6 md:py-20 lg:px-8">
      <div className="rounded-xl border border-primary-200 bg-primary-50 px-6 py-12 text-center md:px-12 md:py-16">
        <h2 className="mx-auto max-w-2xl font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
          {t('home.finalTitle')}
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
          {t('home.finalText')}
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 sm:w-auto"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-shopping-bag-line text-lg"></i>
            </span>
            {t('home.finalCta')}
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-arrow-right-up-line text-lg"></i>
            </span>
            {t('home.finalSecondary')}
          </a>
        </div>
      </div>
    </section>
  );
}